var React = require( 'react' );
var createReactClass = require('create-react-class');

var PartnerLogos = createReactClass({
  render: function(){
    return (
        <img className="partner-logos" src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mth-partner-logos.png" alt="MyGiHealth partners" />
    )
  }
});

module.exports = PartnerLogos;



// WEBPACK FOOTER //
// ./src/common/routes/components/partnerLogos.jsx